<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">开始时间:</span>
          <!-- 开始时间查询 -->
          <el-date-picker v-model="search_data.start_time" type="datetime" placeholder="选择开始时间"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="margin-right: 10px;">
          </el-date-picker>
        </el-col>

        <el-col :span="8">
          <span class="title">结束时间:</span>
          <!-- 结束时间查询 -->
          <el-date-picker v-model="search_data.end_time" type="datetime" placeholder="选择结束时间"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="margin-right: 10px;">
          </el-date-picker>
        </el-col>

        <el-col :span="8">
          <span class="title">推送标题:</span>
          <!-- 推送标题查询 -->
          <el-input v-model="search_data.title" placeholder="查询推送标题" class="handle-input mr10">
          </el-input>
        </el-col>

      </el-row>




      <el-button type="primary" icon="el-icon-search" @click="searchPushLogLists">搜索</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>



      <!-- 选择是否全部推送 -->
      <el-row class="head-search">

        <el-col :span="24" style="margin: 10px 0;">
          <span class="title">是否全部推送:</span>
          <el-radio-group v-model="search_data.all_audience" size="small">
            <el-radio label="" border>
              全部</el-radio>
            <el-radio label="1" border>
              全部推送</el-radio>
            <el-radio label="0" border>
              未全部推送</el-radio>

          </el-radio-group>
        </el-col>

      </el-row>







    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->


            <el-form-item label="指定推送组:">
              <span>{{ props.row.tag }}</span>
            </el-form-item>



            <el-form-item label="指定推送用户:">
              <span>

                {{ props.row.alias }}

              </span>
            </el-form-item>


            <el-form-item label="指定耽搁推送人:">
              <span>

                {{ props.row.registration_id }}

              </span>
            </el-form-item>


            <el-form-item label="推送数据:">
              <span>

                {{ props.row.extras }}

              </span>
            </el-form-item>

            <el-form-item label="返回主体:">
              <span>

                {{ props.row.body }}

              </span>
            </el-form-item>

            <el-form-item label="时间:">
              <span>

                {{ props.row.time.Ymd }}

              </span>
            </el-form-item>

            <el-form-item label="详细时间:">
              <span>{{ props.row.time.YmdHis }}</span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id">
      </el-table-column>

      <el-table-column prop="title" label="推送标题">
      </el-table-column>

      <el-table-column prop="send_no" label="发送编码">
      </el-table-column>


      <el-table-column label="推送状态">

        <template slot-scope="scope">
          {{scope.row.all_audience==='0'?'未全部推送':'全部推送'}}</el-tag>
        </template>

      </el-table-column>



      <el-table-column prop="http_code" label="返回码">
      </el-table-column>


      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


  </div>

</template>

<script>
  var _this;
  export default {
    computed: {
      startTime() {
        return this.search_data.start_time;
      },
      endTime() {
        return this.search_data.end_time;
      }
    },
    watch: {
      startTime(val) {
        if (val == null) {
          this.search_data.start_time = ''
        }
        console.log(val);

      },
      endTime(val) {
        if (val == null) {
          this.search_data.end_time = ''
        }

      }
    },
    data() {
      return {
        // 选择是否全部推送下拉
        value_all_audience: '',

        delDriverSubmit_rules: {
          driver_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },


        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          start_time: '',
          end_time: '',
          title: '',
          all_audience: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.pushLogLists();
    },

    methods: {
      searchPushLogLists(){
        _this.search_data.page = 1;
        _this.pushLogLists();
      },
      // 搜索司机审核列表
      pushLogLists() {
        _this.$post(
            "/log/pushLogLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.pushLogLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>